import React, { memo, useState } from 'react'
import { View, Text, TextInput, TouchableOpacity, ActivityIndicator, StyleSheet } from 'react-native'
import { Feather } from '@expo/vector-icons'
import theme from '../../../../theme'

/**
 * CommentInput - Componente optimizado para el input de comentarios
 * Envuelto en React.memo para prevenir re-renders innecesarios
 */
const CommentInput = memo(
    ({ userToSend, loading, onSend, onClearReply, inputRef, placeholder = 'Añadir un comentario...' }) => {
        const [text, setText] = useState('')
        const [height, setHeight] = useState(35)

        const handleSend = () => {
            if (text.trim() && !loading) {
                const commentText = userToSend ? userToSend + text.trim() : text.trim()
                onSend(commentText)
                setText('')
            }
        }

        const handleClear = () => {
            if (userToSend) {
                onClearReply()
            }
        }

        return (
            <View
                style={[
                    styles.inputContainer,
                    {
                        borderTopColor: theme.colors.extraLightGray,
                        backgroundColor: 'white',
                    },
                ]}
            >
                {userToSend && (
                    <View style={[styles.replyBadge, { backgroundColor: theme.colors.colorPrimaryLight }]}>
                        <Text style={[styles.replyText, { color: theme.colors.colorPrimary }]}>Respondiendo a {userToSend}</Text>
                        <TouchableOpacity onPress={handleClear}>
                            <Text style={[styles.clearButton, { color: theme.colors.colorPrimary }]}>✕</Text>
                        </TouchableOpacity>
                    </View>
                )}
                <View
                    style={{
                        width: '100%',
                        flexDirection: 'row',
                        paddingHorizontal: 5,
                        marginBottom: 15,

                        alignItems: 'center', // opcional, pero ayuda
                    }}
                >
                    <TextInput
                        ref={inputRef}
                        multiline
                        value={text}
                        onChangeText={setText}
                        placeholder={placeholder}
                        placeholderTextColor={theme.colors.mediumGray}
                        style={{
                            flex: 1,
                            minHeight: 20,
                            maxHeight: 120,
                            borderWidth: 0.5,
                            borderColor: theme.colors.lightGray,
                            borderRadius: 15,
                            paddingHorizontal: 10,
                            paddingVertical: 7, // 👈 TRUCO
                            fontSize: 14,
                            backgroundColor: theme.colors.colorBackgroundSecondary,
                            color: theme.colors.textPrimary,
                        }}
                        maxLength={500}
                        returnKeyType='default'
                        blurOnSubmit={false}
                    />
                    {/* {text.length === 0 && (
                        <Text
                            style={{
                                color: theme.colors.mediumGray,
                                textAlignVertical: 'center',
                                paddingStart: 10,
                                position: 'absolute',
                                justifyContent: 'center',
                            }}
                        >
                            {placeholder}
                        </Text>
                    )} */}
                    <TouchableOpacity style={[styles.sendButton]} onPress={handleSend} disabled={!text.trim() || loading}>
                        {loading ? (
                            <ActivityIndicator size='small' color={theme.colors.colorPrimary} />
                        ) : (
                            <Feather name='send' size={20} color={theme.colors.colorPrimary} />
                        )}
                    </TouchableOpacity>
                </View>
            </View>
        )
    },
    (prevProps, nextProps) =>
        prevProps.userToSend === nextProps.userToSend && prevProps.loading === nextProps.loading && prevProps.placeholder === nextProps.placeholder,
)

const styles = StyleSheet.create({
    inputContainer: {
        borderTopWidth: 1,
        paddingHorizontal: 12,
        paddingTop: 8,
    },
    replyBadge: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 12,
        paddingVertical: 6,
        borderRadius: 6,
        marginBottom: 8,
    },
    replyText: {
        fontSize: 12,
        fontWeight: '600',
    },
    clearButton: {
        fontSize: 18,
        fontWeight: 'bold',
        marginLeft: 8,
    },
    inputRow: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        backgroundColor: 'white',
    },
    input: {
        flexShrink: 1, // 👈 evita que el flex del contenedor limite el crecimiento
        borderWidth: 0.5,
        marginRight: 10,
        paddingHorizontal: 10,
        borderRadius: 10,
        borderColor: theme.colors.mediumGray,
        fontSize: 14,
    },
    sendButton: {
        width: 40,
        height: 40,
        borderRadius: 20,
        alignItems: 'center',
        justifyContent: 'center',
    },
})

CommentInput.displayName = 'CommentInput'

export default CommentInput
